export default __webpack_public_path__ + "static/media/button-small-inactive@2x.5610fef1.png";